import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=23aa6b9e&"
import script from "./InputTel.vue?vue&type=script&lang=ts&"
export * from "./InputTel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports